/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function moveToPending(item: MoveableItem): any {
  return {
    ...item,
    additionalWork: false,
    show: false,
    use_total: false,
    pending: true,
    addedOption: false
  }
}
